
import { vec3 } from 'gl-matrix';

WL.registerComponent('bullet', {
}, {
  init: function() {
    this.isFlying = false;
    this.mesh = this.object.getComponent('mesh');
    this.mesh.active = false;

    this.pos = vec3.create();
    this.origin = vec3.create();
    this.direction = vec3.create();
    this.destination = vec3.create();
    this.distance = 0;
    this.lerpAmount = 0;
    this.speed = 50; // In meters/second
    this.timeToTravel = 0; // In seconds

    this.object.scalingWorld = [0.02, 0.02, 0.02];
  },
  shoot: function(origin, destination, distance) {
    this.origin = Object.values(origin);
    this.destination = Object.values(destination);
    this.distance = distance;
    this.timeToTravel = this.distance / this.speed;
    this.object.setTranslationWorld(this.origin);
    this.mesh.active = true;
    this.isFlying = true;
  },
  update: function(dt) {
    if (!this.isFlying) return;
    vec3.lerp(this.pos, this.origin, this.destination, this.lerpAmount);
    this.lerpAmount += dt / this.timeToTravel;
    if (this.lerpAmount > 1) {
      this.reset();
    } else {
      this.object.setTranslationWorld(this.pos);
    }
  },
  reset: function() {
    this.isFlying = false;
    this.mesh.active = false;
    this.object.setTranslationWorld(this.origin);
    this.lerpAmount = 0;
  },
});
